export default "__VITE_ASSET__BDpj8Spq__"